import { forwardRef, Select, SelectProps } from '@chakra-ui/react';
import { FC } from 'react';

export interface SelectFieldProps extends SelectProps {
  options: any[];
}

export const SelectField: FC<SelectFieldProps> = forwardRef<
  SelectFieldProps,
  'select'
>(({ defaultValue, options, ...rest }, ref) => (
  <Select
    {...rest}
    ref={ref}
    placeholder="Select"
    defaultValue={defaultValue}
    borderRadius="4px"
  >
    {options.map((option, i) => {
      const label = option.label ?? option;
      const value = option.value ?? option;
      return (
        <option key={`${i}-${label}`} value={value}>
          {label}
        </option>
      );
    })}
  </Select>
));
